import { styled, css } from 'styled-components';
import { motion } from 'framer-motion';
interface ContainerProps {
  status?: 'Aborted' | 'Ready' | 'Failed' | 'Processing' | 'Uploaded';
  $uploadProgress: number;
}

export const Container = styled(motion.li)<ContainerProps>`
  ${({ status = 'Processing', theme: { colors }, $uploadProgress }) => {
    const backgroundOptions = {
      Aborted: 'white',
      Ready: colors.semanticSuccessTint90,
      Failed: colors.semanticDangerTint90,
      Processing: 'transparent',
      Uploaded: colors.brandPrimaryTint90,
    } as const;

    return css`
      display: flex;
      box-sizing: border-box;
      flex-flow: row wrap;
      padding: 0.5rem 1rem 0.5rem 1.5rem;
      min-height: 3rem;
      background-size: ${status === 'Processing' ? `${$uploadProgress}% 100%` : '0% 0%'};
      background-color: ${backgroundOptions[status]};
      background-image: linear-gradient(${colors.brandPrimaryTint90}, ${colors.brandPrimaryTint90});
      background-repeat: no-repeat;
      transition: ${$uploadProgress !== 100 ? `all 0.25s ease-in-out` : 'none'};
      width: 100%;
    `;
  }}
`;

export const ContentBar = styled.div`
  ${({ theme: { colors } }) => css`
    gap: 1rem;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
    background-color: transparent;
    align-items: center;
    display: flex;

    .icon {
      height: 1.2rem;
      width: 1.2rem;
    }

    .type-icon {
      height: 1.5rem;
      width: 1.5rem;
    }

    .spinner {
        fill: ${colors.brandPrimary} !important;

        path {
          stroke: ${colors.brandPrimary} !important;
        }
      }
    }

    &:hover {
      .cancel-button {
        display: block;
      }
    }

    .cancel-button {
      display: none;
    }
  `}
`;

export const FileInfo = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  flex: 1;
  overflow: hidden;
  gap: 1rem;

  .cancelled-text {
    flex-shrink: 0;
  }
`;

export const NameContainer = styled.div`
  overflow: hidden;
  flex: 1;

  p {
    display: block;
    -webkit-line-clamp: unset;
    -webkit-box-orient: unset;
    line-height: 1.2em;
  }

  p:not(.sub-message) {
    white-space: nowrap;
  }

  .text {
    width: 100%;
  }
`;

export const StatusIcon = styled.div`
  align-items: center;
  display: flex;
`;
